<template>
    <div class="book-now-content">
        <div class="book-now-center">
            <div class="title">Contact Us</div>
            <el-form :model="userInfo" :rules="rules" ref="form">
                <div class="from">
                    <div class="from-input" @click="$refs.newNameInput.focus()">
                        <div class="left">
                            <div class="left-title"><span style="color: red;">*</span>First Name</div>
                            <el-form-item prop="newName">
                                <div class="input">
                                    <el-input ref="newNameInput"  v-model="userInfo.newName" :maxlength="100"></el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <!-- <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line1.png" alt=""></div> -->
                    </div>
                    <div class="from-input" @click="$refs.oldNameInput.focus()">
                        <div class="left">
                            <div class="left-title">Last Name</div>
                            <el-form-item prop="oldName">
                                <div class="input">
                                    <el-input  ref="oldNameInput" v-model="userInfo.oldName"></el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <!-- <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line1.png" alt=""></div> -->
                    </div>
                    <div class="from-input" @click="$refs.emailInput.focus()">
                        <div class="left">
                            <div class="left-title"><span style="color: red;">*</span>Email Address</div>
                            <el-form-item prop="email">
                                <div class="input">
                                    <el-input ref="emailInput" v-model="userInfo.email" :maxlength="100"></el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <!-- <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line1.png" alt=""></div> -->
                    </div>
                    <div class="from-input" @click="$refs.phoneInput.focus()">
                        <div class="left">
                            <div class="left-title"><span style="color: red;">*</span>Phone</div>
                            <el-form-item prop="phone">
                                <div class="input">
                                    <el-input ref="phoneInput" v-model="userInfo.phone" @input="validatePositiveInteger(userInfo.phone,3)" :maxlength="20"></el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <!-- <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line1.png" alt=""></div> -->
                    </div>
                    <!-- <div class="from-input">
                        <div class="left">
                            <div class="left-title"><span style="color: red;">*</span>Arrival Date</div>
                            <el-form-item prop="arrivalDate">
                                <div class="input">
                                    <div class="block">
                                        <el-date-picker 
                                        v-model="userInfo.arrivalDate" 
                                        type="date" 
                                        :picker-options="pickerOptions" 
                                        @input="startTimeChange"
                                        ></el-date-picker>
                                    </div>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/from/time.png" alt=""></div>
                    </div> -->
                    <!-- <div class="from-input end-time-input">
                        <div class="left">
                            <div class="left-title"><span style="color: red;">*</span>Departure Date</div>
                            <el-form-item prop="departureDate">
                                <div class="input">
                                    <div class="block">
                                        <el-date-picker 
                                        v-model="userInfo.departureDate" 
                                        type="date" 
                                        :picker-options="departurePickerOptions" 
                                        :disabled="isInputMask ? true : false"
                                        ></el-date-picker>
                                    </div>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/from/time.png" alt=""></div>
                        <div class="mask" v-show="isInputMask" @click="endTimeClickNoticeEvent"></div>
                    </div> -->
                    <!-- <div class="from-input">
                        <div class="left">
                            <div class="left-title"><span style="color: red;">*</span>Adults</div>
                            <el-form-item prop="adults">
                                <div class="input">
                                    <el-input 
                                    :maxlength="3"
                                    v-model="userInfo.adults" 
                                    @input="validatePositiveInteger(userInfo.adults,1)"></el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line2.png" alt=""></div>
                    </div> -->
                    <!-- <div class="from-input">
                        <div class="left">
                            <div class="left-title"><span style="color: red;">*</span>Children (≤13)</div>
                            <el-form-item prop="child">
                                <div class="input">
                                    <el-input 
                                    :maxlength="3" 
                                    v-model="userInfo.child" 
                                    @input="validatePositiveInteger(userInfo.child,2)"></el-input>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line2.png" alt=""></div>
                    </div> -->
                </div>
                <div class="choose">
                    <div class="text">
                        Would you like to be contacted by a travel consultant?<span style="color: red;">*</span>
                    </div>
                    <div class="radio">
                        <div class="radio-item" v-for="item in radioList" :key="item.id">
                            <div class="img" :class="{'notActive':userInfo.radio != item.id}" @click="radioClickEvent(item.id)"><img loading="lazy"  v-show="userInfo.radio == item.id" src="../../../static/img/bookNow/from/Checklist.png" alt=""></div>
                            <div class="info">{{item.info}}</div>
                        </div>
                    </div>
                </div>
                <div class="textarea">
                    <div class="textarea-title">Message the host</div>
                    <el-form-item prop="message">
                        <el-input
                            type="textarea"
                            :rows="2"
                            placeholder="Tell us more about your trip, such as your desired destination, budget per person per day, etc…"
                            v-model="userInfo.message"
                            maxlength="800"
                            show-word-limit
                        >
                        </el-input>
                    </el-form-item>
                </div>
                <el-form-item>
                    <div class="submit" @click="submitForm"><div class="btn">submit</div><img loading="lazy"  src="../../../static/img/bookNow/from/right.png" alt=""></div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import rulesDetials from '../../../js/fromRules/rulesDetials.js';
    export default{
        data(){
            return{
                userInfo: {
                    newName: '',
                    oldName: '',
                    email: '',
                    phone: '',
                    // arrivalDate: '',
                    // departureDate: '',
                    // adults: '',
                    // child: '',
                    message: '',
                    radio: '1',
                },
                rules:rulesDetials.rules,
                radioList:[
                    {
                        id:1,
                        info:'Yes'
                    },
                    {
                        id:2,
                        info:'No'
                    }
                ],
            }
        },
        methods:{
                // 验证人数
            validatePositiveInteger(value,id) {
                if (/^[1-9]\d*$/.test(value)) {
                    // 如果是正整数
                    if (id === 1) {
                        this.userInfo.adults = value;
                    } 
                    // else if (id === 2) {
                    //     this.userInfo.child = value;
                    // } else if (id === 3) {
                    //     this.userInfo.phone = value;
                    // }
                } else {
                    // 如果不是正整数，清空相应的字段
                    if (id === 1) {
                        this.userInfo.adults = '';
                    } 
                    // else if (id === 2) {
                    //     this.userInfo.child = '';
                    // } else if (id === 3) {
                    //     this.userInfo.phone = '';
                    // }
                }
            },
            radioClickEvent(id){
                this.userInfo.radio = id
            },
            // 判断是否输入开始时间
            // startTimeChange() {
            //     this.isInputMask = startTimeChangeWay(this.userInfo.arrivalDate)
            // },
            // 先选结束时间进行提示
            // endTimeClickNoticeEvent(){
            //     this.$message({
            //         message: 'Please select the arrival date',
            //         type: 'warning'
            //     });
            // },
            // 提交表单
            submitForm() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        if(this.userInfo.phone.length < 3){
                            this.$message({
                                message: 'Please enter a valid phone number',
                                type: 'warning'
                            });
                            return
                        }else{
                            this.$axios.post('/submit', this.userInfo)
                            .then(response => {
                                this.$message({
                                    message:response.message,
                                    type: 'success'
                                });
                            })
                            .catch(error => {
                                this.$message.error(error.message) // 处理错误
                            });
                        }
                        
                    } else {
                        this.$message({
                            message: 'Please fill in all required fields and ensure that the input is correct',
                            type: 'warning'
                        });
                    }
                });
            },
        }
    }
</script>
<style scoped lang="scss">
@import '/style/pc/bookNow/fromMoveNow.scss';
@import '/style/pc/common/radio.scss';
@import '/style/phone/bookNow/fromMoveNow.scss';
</style>
